import { AfterViewInit, Component, OnInit } from '@angular/core';
import { GlobalSettingsService } from 'src/app/services/ui/global-settings.service';
import { BaseBinderWizardService } from 'src/app/services/interfaces/base-binder-wizard-service';
import { BinderSessionWizardService } from 'src/app/services/sections/binder/binder-session-wizard.service';

@Component({
  selector: 'binder-session',
  templateUrl: './binder-session.component.html',
  styleUrls: ['./binder-session.component.scss'],
  providers: [
    { provide: BaseBinderWizardService, useClass: BinderSessionWizardService }
  ]
})
export class BinderSessionComponent implements OnInit, AfterViewInit {

  constructor() { }

  ngOnInit(): void {}

  ngAfterViewInit(): void {
  }
}
